import React, { useEffect, useState } from "react";
import OnboardingTour, {
  hasSeenOnboarding,
  OPEN_EVENT,
} from "@/components/OnboardingTour";
import { useAuth } from "@/context/AuthContext";

/**
 * Global host for the onboarding tour.
 *  - Auto-opens the tour once, the first time an authenticated user is
 *    detected AND the "seen" flag is missing (first login).
 *  - Also listens to a global `spectraloom:open-tour` event dispatched by
 *    the header "Replay tour" button so the tour can be re-opened on demand
 *    from any page.
 */
export default function OnboardingHost() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  // First-login auto-open
  useEffect(() => {
    if (!user) return undefined;
    if (hasSeenOnboarding()) return undefined;
    const t = setTimeout(() => setOpen(true), 350);
    return () => clearTimeout(t);
  }, [user?.user_id]);

  // Manual re-open via header button (fires custom event)
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(OPEN_EVENT, handler);
    return () => window.removeEventListener(OPEN_EVENT, handler);
  }, []);

  if (!open) return null;
  return (
    <OnboardingTour
      userName={user?.name || ""}
      onFinish={() => setOpen(false)}
    />
  );
}
